import axiosInstance from './axiosConfig';

function buildQueryString(values: Record<string, string | number>): string {
    return Object.entries(values)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join("&");
}

export const getRelatorio = async (campaignId: number) => {
    const response = await axiosInstance.get(`/report/delivery-by-publisher/${campaignId}`);
    return response?.data;
}

export const getDownloadGeneralReport = async (campaignId: number, values: Record<string, string | number>) => {
    return await axiosInstance.get(`/report/general-report/${campaignId}?${buildQueryString(values)}`, { responseType: "blob" });
}

export const getDownloadVerificationReport = async (campaignId: number, values: Record<string, string | number>) => {
    return await axiosInstance.get(`/report/verification-report/${campaignId}?${buildQueryString(values)}`, { responseType: "blob" });
}

export const getDownloadBlockedReport = async (campaignId: number, values: Record<string, string | number>) => {
    return await axiosInstance.get(`/report/blocked-report/${campaignId}?${buildQueryString(values)}`, { responseType: "blob" });
}

export const getReportByDay = async (campaignId: number) => {
    const response = await axiosInstance.get(`/report/delivery-by-day/${campaignId}`);
    return response?.data;
}

export const getRelatorioPorTipoDeCompra = async (campaignId: number) => {
    const response = await axiosInstance.get(`/report/pricing-model/${campaignId}`);
    return response?.data;
}

export const getCategoriasMaisAcessadas = async (campaignId: number) => {
    const response = await axiosInstance.get(`/report/most-accessed-categories/${campaignId}`);
    return response?.data;
}

export const getImpressoesPorEstado = async (campaignId: number) => {
    const response = await axiosInstance.get(`/report/impressions-by-state/${campaignId}`);
    return response?.data;
}

export const getImpressoesPorPais = async (campaignId: number) => {
    const response = await axiosInstance.get(`/report/impressions-by-country/${campaignId}`);
    return response?.data;
};

export const getImpressoesPorDispositivo = async (campaignId: number) => {
    const response = await axiosInstance.get(`/report/impressions-by-device/${campaignId}`);
    return response?.data;
};

export const getPaginasMaisAcessadas = async (campaignId: number) => {
    const response = await axiosInstance.get(`/report/most-visited-pages/${campaignId}`);
    return response?.data;
};

export const getPaginasBloqueadas = async (campaignId: number) => {
    const response = await axiosInstance.get(`/report/blocked-pages/${campaignId}`);
    return response?.data;
};

export const getHeatmap = async (campaignId: number) => {
    const response = await axiosInstance.get(`/report/heatmap/${campaignId}`);
    return response?.data;
};

export const getPaginasDeReferencia = async (campaignId: number) => {
    const response = await axiosInstance.get(`/report/referer-page/${campaignId}`);
    return response?.data;
};

export const getEntregasPorIp = async (campaignId: number) => {
    const response = await axiosInstance.get(`/report/delivery-by-ip/${campaignId}`);
    return response?.data;
}

export const getEntregasPorUser = async (campaignId: number) => {
    const response = await axiosInstance.get(`/report/delivery-by-user/${campaignId}`);
    return response?.data;
}

export const getVastErrosByDay = async (campaignId: number) => {
    const response = await axiosInstance.get(`/report/vast-errors-by-day/${campaignId}`);
    return response?.data;
}
